import type { DealState } from '@kia/shared';

/**
 * The ONE authority for "can this deal seed a release-prep (حواله) card?" (FLOW-1). A حواله is prepared only
 * from a firm order that still has open lines: a Confirmed deal (awaiting dispatch) or a partially-Delivered
 * one. A Closed deal has nothing left to release — offering the deep-link button on it would land the preparer
 * on an empty PrepareCard (an NS-1 soft dead-end). PrepareCard's own dropdown filters on this exact set, so
 * both the dropdown and the deal→prep button MUST read it from here or they drift.
 */
const RELEASE_PREP_STATES: readonly DealState[] = ['Confirmed', 'Delivered'];

export function isReleasePrepEligible(state: string): boolean {
  return (RELEASE_PREP_STATES as readonly string[]).includes(state);
}
